<template>
  <div class="nav">
    <div class="nav-left"><span style="width: 90px;overflow: hidden;margin-left: 20px;">当前位置:</span><span
        class="navText">{{ projectName }}</span><span v-show="sectionName !=''"
        class="navText">{{ '>' + sectionName }}</span><span class="navText"
        v-show="buildName !='' ">{{ '>' + buildName }}
      </span><span class="navText" v-show="projectSiteName !='' ">{{ '>' + projectSiteName }}</span></div>
    <div class="nav-right">

      <el-menu :default-active="$route.path" class="el-menu-demo" mode="horizontal" background-color="#0090CA"
        text-color="#000" active-text-color="#000000" router>
        <el-menu-item index="/home/totalAnalyze">首页</el-menu-item>
        
        <el-submenu index='/constructionManagement' :show-timeout='100' :hide-timeout='100'
          :popper-append-to-body='false'>
          <template slot="title">施工管理</template>
          <el-menu-item index="/constructionManagement/secQualityAnalysis">二衬质量分析</el-menu-item>
          <el-menu-item index="/constructionManagement/flatnessAnalysis">初支平整度</el-menu-item>
          <el-menu-item index="/constructionManagement/volumeSquareAnalysis">二衬方量</el-menu-item>
          
         <el-menu-item index="/constructionManagement/initialThicknessAnalysis">初支厚度分析</el-menu-item>
          <el-menu-item index="/constructionManagement/invertedLimitAnalysis">仰拱侵限分析</el-menu-item>
          
        </el-submenu>

        <el-submenu index='/assessingManagement' :show-timeout='100' v-if="$store.state.userRole=='建设'"
          :hide-timeout='100' :popper-append-to-body='false'>
          <template slot="title">考核管理</template>
          <el-menu-item index="/assessingManagement/volumeSquareAnalysisAssess">二衬方量考核</el-menu-item>
          <el-menu-item index="/assessingManagement/flatnessAnalysisAsses">初支平整度考核</el-menu-item>
          <el-menu-item index="/assessingManagement/threeInspectionAssessments">三检考核</el-menu-item>
        </el-submenu>


        <el-submenu index='/detectionManagement' :show-timeout='100' :hide-timeout='100' :popper-append-to-body='false'>
          <template slot="title">检测管理</template>
          <el-menu-item index='/detectionManagement/detectionStatistics'>检测统计</el-menu-item>
          <el-menu-item index='/detectionManagement/detectionOverdue'>检测逾期</el-menu-item>
          <el-menu-item index='/detectionManagement/thirdPartyInspection'>第三方检测</el-menu-item>
        </el-submenu>

        <el-submenu index='/defectManagement' :show-timeout='100' :hide-timeout='100' :popper-append-to-body='false'>
          <template slot="title">缺陷管理</template>
          <el-menu-item index='/defectManagement/defectStatistics'>缺陷统计</el-menu-item>
          <el-menu-item index='/defectManagement/problemBase'>问题库</el-menu-item>
        </el-submenu>

        <el-submenu index='/systemManagement' :show-timeout='100' :hide-timeout='100' :popper-append-to-body='false'>
          <template slot="title">系统管理</template>
          <el-menu-item index="/systemManagement/deviceManager" v-if="$store.state.treeNode.nodeGrade<=2">设备管理
          </el-menu-item>
          <el-menu-item index="/systemManagement/SMS_Settings"
            v-if="$store.state.userRole=='建设'|| $store.state.userPermission=='1'">短信配置</el-menu-item>
          <el-menu-item index="/systemManagement/employeeManager"
            v-if="$store.state.userPermission=='1' || $store.state.userPermission=='2'">人员管理</el-menu-item>
          <el-menu-item index="/systemManagement/importProject" v-if="$store.state.userPermission=='1'">项目数据录入
          </el-menu-item>
          <el-menu-item index="/systemManagement/importSection" v-if="$store.state.userPermission=='1'">标段数据录入
          </el-menu-item>
          <el-menu-item index="/systemManagement/importProjectSite" v-if="$store.state.userPermission=='1'">工点数据录入
          </el-menu-item>
          <el-menu-item index="/systemManagement/importDeductibleSquare" v-if="$store.state.userPermission=='1'">
            核算扣除方量录入</el-menu-item>
          <el-menu-item index="/systemManagement/effectiveRange" v-if="$store.state.treeNode.nodeGrade == 4">工点有效里程范围设置
          </el-menu-item>
          <el-menu-item index="/systemManagement/logRecord" v-if="$store.state.userPermission == '1'">日志记录
          </el-menu-item>
        </el-submenu>
        <el-submenu index='/thresholdSetting' :show-timeout='100' :hide-timeout='100' :popper-append-to-body='false'
          v-if="$store.state.userRole == '监理'">
          <template slot="title">阈值设置</template>
          <el-menu-item index="/thresholdSetting/volumeThreshold">方量阈值</el-menu-item>
          <el-menu-item index="/thresholdSetting/flatnessThreshold">平整度阈值</el-menu-item>
          <el-menu-item index="/thresholdSetting/pouringThreshold"
            v-show="$store.state.userPermission=='1' || $store.state.userPermission=='2'">浇筑时间阈值</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

  </div>
</template>

<script>
  import VueEventBus from '@/model/VueEventBus'
  import {
    getDistanceDays
  } from '@/common/js/periodOfValidity.js'
  import {
    projectInfoById,
    buildById,
    projectSectionById,
    projectsiteById
  } from '@/common/api.js'
  export default {
    name: "Nav",
    data() {
      return {
        // permission: undefined,
        activeIndex: '1',
        loginAccount: '',
        username: '',
        kaiwaProjectTableData: [],
        initProjectTableData: [],
        secProjectTableData: [],
        kaiwaSectionTableData: [],
        initSectionTableData: [],
        secSectionTableData: [],
        kaiwaBuildTableData: [],
        initBuildTableData: [],
        secBuildTableData: [],
        kaiwaProjectSiteTableData: [],
        initProjectSiteTableData: [],
        secProjectSiteTableData: [],
        value: '超欠挖',
        projectName: '',
        sectionName: '',
        buildName: '',
        projectSiteName: '',
        projectId: 1,
        sectionId: '',
        projectSiteId: '',
        buildId: '',
        nodeGrade: 1,
        currentIndex: 0,
        projectsiteIds: [],
        // permission: 0,
        periodOfValidity: null,
      }


    },


    mounted() {
      VueEventBus.$on('projectSiteList', (val) => {
        this.nodeGrade = sessionStorage.getItem('nodeGrade')
      })


    },
    created() {
      this.periodOfValidity = getDistanceDays(this.getBeforeDate(0), this.$store.state.periodOfValidity)
      VueEventBus.$on('defaultProjecSiteList', (val) => {
        this.projectsiteIds = val
      })
      VueEventBus.$on('navCurrentChange', (val) => {
        this.currentIndex = val
      })





    },
    methods: {
      changeNav(index, url) {
        this.$router.push({
          name: url,
          params: {
            // path:'/home'
          }
        })
        this.currentIndex = index
      },
      getBeforeDate(n) {
        var n = n;
        var d = new Date();
        var year = d.getFullYear();
        var mon = d.getMonth() + 1;
        var day = d.getDate();
        if (day <= n) {
          if (mon > 1) {
            mon = mon - 1;
          } else {
            year = year - 1;
            mon = 12;
          }
        }
        d.setDate(d.getDate() - n);
        year = d.getFullYear();
        mon = d.getMonth() + 1;
        day = d.getDate();
        let s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
        return s;
      },
    },
    watch: {
      '$store.state.treeNode': function(val) {
        if (val.nodeGrade == 0) {
          this.projectName = val.label
        } else if (val.nodeGrade == 1) {
          this.projectName = val.label
          this.sectionName = ''
          this.buildName = ''
          this.projectSiteName = ''
        } else if (val.nodeGrade == 2) {
          this.projectName = val.projectName
          this.sectionName = val.label
          this.buildName = ''
          this.projectSiteName = ''
        } else if (val.nodeGrade == 3) {
          this.projectName = val.projectName
          this.sectionName = val.sectionName
          this.buildName = val.label
          this.projectSiteName = ''
        } else if (val.nodeGrade == 4) {
          this.projectName = val.projectName
          this.sectionName = val.sectionName
          this.buildName = val.buildName
          this.projectSiteName = val.label
        }
      }
    },
    updated() {

    },
  }
</script>

<style scoped>
  .nav {
    /* height: 80px; */
    width: 100%;
    /* position: fixed; */

    /* background: url(../assets/navBackground.png) no-repeat; */
    background-size: 100%;

    display: flex;

    flex-direction: column-reverse;
    align-items: center;
    justify-content: space-between;
    z-index: 200 !important;
    font-size: 1rem;
    align-items: flex-start;
    /* position: fixed; */
    

  }

  .nav-left {
    width: 100%;
    height: 35px;
    line-height: 35px;
    display: flex;
    color: #ffffff;
    background-color: #32A5D5;
    font-size: 0.8rem;
  }

  .nav-left span {
    font-weight: bold;

  }

  .nav-left .navText {
    /* flex: auto; */
    overflow: hidden;

    font-weight: normal;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .nav-right {
    /* width: 30%; */
    width: 100%;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    /* padding-left: 20px; */
    font-size: 1em;
    background-color: #0090CA;
    /* overflow-y: hidden;
    overflow-x: visible; */
  }

  .nav-right-link {
    color: #000000;
    text-decoration: none;
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    justify-content: center;
    height: 100%;
    width: 80px;
    cursor: pointer;
    /* padding: 0 20px; */
  }

  .active {

    background-color: #FFFFFF;

  }

  .router-link-active {
    background-color: #FFFFFF;

  }

  .el-input {
    width: 60% !important;
    margin-left: 4px;
    height: 38px;
    border-radius: 0;
  }

  .el-input__inner {

    margin-left: 4px;
    height: 20px !important;
  }

  .el-input--suffix .el-input__inner {
    width: 20px !important;
    margin-left: 4px;
    height: 38px !important;
    width: 20px !important;
    padding: 0 !important;
  }

  .el-input__icon {
    height: 105%;
  }

  .el-input__prefix {
    top: 0px;
  }

  .el-menu {
    display: flex !important;
    width: 100% !important;
  }

  element.style {
    color: rgb(0, 0, 0);
    border-bottom-color: transparent;
    background-color: rgb(0, 144, 202);
  }

  .el-menu--horizontal>.el-menu-item {
    /* float: left; */
    height: 50px !important;
    line-height: 50px !important;
    margin: 0;
    border-bottom: 2px solid transparent;
    color: #909399;
    /* display: flex; */
    /* width: 80px; */
    text-align: center;
    font-size: 16px;
  }


  .el-menu--horizontal>.el-menu-item.is-active {
    border-bottom: none !important;
    background-color: #FFFFFF !important;
  }

  .el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 50px !important;
    line-height: 50px !important;
    border-bottom: none !important;
    background-color: #FFFFFF !important;
  }

  .nav-right>>>.el-submenu__title i {
    color: #000000 !important;
    /* width: 80px !important; */
  }

  .nav-right>>>.el-menu--horizontal>.el-submenu .el-submenu__title {
    height: 50px !important;
    line-height: 50px !important;
    border-bottom: none !important;
    font-size: 16px;
  }

  .nav-right>>>.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    background-color: #ffffff !important;
    height: 50px !important;
    line-height: 50px !important;
    border-bottom: none !important;
  }

  .el-menu--horizontal .el-menu .el-menu-item.is-active {
    background-color: #FFFFFF !important;
    width: 100% !important;
    border-bottom: none !important;
  }

  .nav-right>>>.el-menu--collapse .el-menu .el-submenu,
  .nav-right>>>.el-menu--popup {
    min-width: 100px !important;
  }

  .nav-right>>>.el-submenu.is-disabled .el-menu-item,
  .nav-right>>>.el-submenu.is-disabled .el-submenu__title {
    opacity: 0 !important;
    cursor: not-allowed;
  }

  .nav-right>>>.el-menu--popup-bottom-start {
    min-width: 100px !important;
  }

  .nav-right>>>.el-menu--popup {
    width: 150px !important;

  }

  .nav-right>>>.el-submenu .el-menu-item {
    min-width: 150px !important;
  }

  .nav-right>>>.secondNav {
    position: fixed;
    right: 230px !important;
    min-width: 100px !important;

  }

  .nav-right>>>.secondNav .el-menu--popup-right-start {
    min-width: 100px !important;
  }

  .el-menu--popup {
    min-width: 100px !important;
  }

  .el-menu--popup-right-start {
    min-width: 100px;
  }

  .el-menu.el-menu--horizontal {
    border: none;
  }
</style>
<style>
  .el-menu--popup {
    min-width: 100px !important;
  }

  .el-menu--popup-right-start {
    min-width: 100px;
  }

  .nav-right>>>.secondNav .el-menu-item {
    background-color: #008000;
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/Nav.vue